import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import reducers from "./reducers/index";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

//store takes couple of arguments, the first is reducers, and second is state
//It will aslo take middleware such as thunk or saga

const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));

export default store;
